import Vue from "vue";
import VueRouter from "vue-router";
import authService from '@/auth.service';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import App from "./App.vue";

// LightBootstrap plugin
import LightBootstrap from "./light-bootstrap-main";

// Correctly import the allRoutes from routes.js
import routes from "./routes/routes";

import "./registerServiceWorker";
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';




// Plugin setup
Vue.use(VueRouter);
Vue.use(LightBootstrap);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

// Retrieve permissions from localStorage or other source
const storedPermissions = localStorage.getItem('PERMISSIONS'); 
const permissionsArray = JSON.parse(storedPermissions || '[]');

// Check that permissionsArray and allRoutes are correctly structured
console.log('Permissions Array:', permissionsArray);
console.log(routes);

// Extract permission names into a set for quick lookup
const permissionNames = new Set(
  permissionsArray.map(permission => permission.permission_name)
);

// Filter routes based on permissions
const filteredRoutes = routes.filter(route =>
  permissionNames.has(route.path) || 
  route.name === 'LoginView' || 
  route.name === 'DashboardLayout' || 
  route.name === 'IssuetrackingCreate'
  
);

// Configure router
const router = new VueRouter({
  mode: 'history',
  routes: filteredRoutes,
  linkActiveClass: "nav-item active",
  scrollBehavior: (to) => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
});

// Router navigation guards
// Router navigation guards
router.beforeEach((to, from, next) => {
  console.log('Navigating from:', from, 'to:', to);

  // Check if the user is not logged in
  if (!authService.isLoggedIn()) {
    // Allow access to specific pages like LoginView or IssuetrackingCreate
    if (to.name === 'LoginView' || to.name === 'IssuetrackingCreate') {
      next(); // Allow access to the page
    } else {
      next({ name: 'LoginView' }); // Redirect to login page
    }
    return; // Exit the guard
  }

  // Ensure permissions are loaded
  if (permissionsArray.length === 0) {
    // Fetch permissions from localStorage or a backend if necessary
    const storedPermissions = localStorage.getItem('PERMISSIONS'); 
    permissionsArray.push(...JSON.parse(storedPermissions || '[]'));
  }

  // Extract permission names into a set for quick lookup
  const permissionNames = new Set(
    permissionsArray.map(permission => permission.permission_name)
  );

  // Check if the route is permitted
  if (to.name !== 'LoginView' && to.name !== 'IssuetrackingCreate' && !permissionNames.has(to.path)) {
    alert('You do not have permission to access this page.');
    next(false); // Prevent navigation
    return; // Exit the guard
  }

  // If logged in and permission check passes, proceed with navigation
  next();
});


// Handle session timeout
if (authService.isLoggedIn()) {
  setTimeout(() => {
    localStorage.removeItem('ACCESS_TOKEN');
    window.location.href = "/login";
  }, 14400000); // 4 hours
}

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: (h) => h(App),
  router,
});
